import { md5 } from "js-md5";

/**
 * Backend `UserController.java:1207` validates:
 *   signtureCheck = md5SaltEncrypt(username + password + timestamp.slice(-5))
 *
 * "salt" in `md5SaltEncrypt` is empty by default in the controller path —
 * this is plain MD5(string). The `signture` (legacy spelling) header is
 * required for /user/register; missing it yields 400.
 */
export function computeSignture(username: string, password: string, timestamp: string): string {
  const last5 = timestamp.slice(-5);
  return md5(username + password + last5);
}

/** Millisecond-precision epoch as string — what the backend reads from the `timestamp` header. */
export function nowTimestamp(): string {
  return String(Date.now());
}
